import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form'
import Button from '../button'
import Input from 'antd/es/input'

type Result = {
  email: string
}

type Props = {
  visible: boolean
  onSave: ({ email }: Result) => void
  onCancel: () => void
}

export const ResetPassword = (props: Props) => {
  const [form] = Form.useForm()
  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  const onFinish = (result: Result) => {
    props.onSave(result)
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal
      visible={props.visible}
      title={`Palauta salasana`}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => {
              props.onCancel()
            }}
            color="default"
          />
          <Button
            label="Lähetä"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {/* password */}
        <Form.Item label={'Sähköposti'} name="email" rules={[{ required: true, message: 'Anna sähköposti' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ResetPassword
